import { ThemeToggle } from "@/components/common/ThemeToggle";

type Props = {
  title: string;
  onDelete?: () => void;
  guest?: boolean;
  onMenu?: () => void;
};

export function ConversationHeader({ title, onDelete, guest, onMenu }: Props) {
  return (
    <header className="sa-chat-header">
      {onMenu && (
        <button
          type="button"
          className="sa-chat-header__menu"
          onClick={onMenu}
          aria-label="Open conversations"
        >
          Menu
        </button>
      )}

      <div style={{ minWidth: 0 }}>
        <div className="sa-label" style={{ fontSize: 10, marginBottom: 4 }}>
          {guest ? "Guest Inquiry - not saved" : "Conversation"}
        </div>
        <h2
          className="sa-chat-header__title"
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 500,
            fontSize: 20,
            margin: 0,
            letterSpacing: "-0.01em",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 560,
          }}
        >
          {title}
        </h2>
      </div>

      <div
        className="sa-chat-header__actions"
        style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}
      >
        <ThemeToggle />
        {onDelete && !guest && (
          <button
            className="sa-chat-header__delete"
            onClick={onDelete}
            style={{
              background: "transparent",
              border: "1px solid var(--sa-border-strong)",
              padding: "6px 12px",
              fontFamily: "var(--sa-sans)",
              fontSize: 12,
              cursor: "pointer",
              color: "var(--sa-muted-fg)",
              borderRadius: 2,
            }}
          >
            Delete
          </button>
        )}
      </div>
    </header>
  );
}
